import mergeModuleConfigs from 'core/utils/mergeModuleConfigs';
import { bonusOffers300x250 as orgConfig } from 'org/configs/modules.config';

const defaultConfig = {
  defaults: {
    minNumberOfBonusOffersToRenderSection: 3,
    title: 'Stores offering bonus rewards',
    shouldShowTitleLink: true,
    useCarousel: true,
    carousel: {
      hasDots: false,
      hasArrows: false,
      isClipped: true,
      breakpoints: {
        m: { isClipped: false },
        l: { hasArrows: true },
      },
    },
  },
  sp: {
    offersLimit: 2,
  },
  fs: {
    offersLimit: 2,
  },
};

export default mergeModuleConfigs(defaultConfig, orgConfig);
